import { render, staticRenderFns } from "./PromotionApproveModal.vue?vue&type=template&id=b2691fe8&scoped=true&"
import script from "./PromotionApproveModal.vue?vue&type=script&lang=js&"
export * from "./PromotionApproveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2691fe8",
  null
  
)

export default component.exports